export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum ModalType {
	ERROR,
	CONFIRM,
	SECONDARY_REGISTRATION,
	SAVE_LOCAL_PREDICTION,
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum SocialType {
	Facebook = "facebook",
	Twitter = "twitter",
	Whatsapp = "whatsapp",
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum Locale {
	EN_US = "en-US",
	ES_ES = "es-ES",
}

export enum Language {
	EN = "en",
	ES = "es",
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum LeagueType {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	COMPLETE = "complete",
	PLAYING = "playing",
	SCHEDULED = "scheduled",
}

export enum ContestStatus {
	LIVE = "live",
	SCHEDULED = "scheduled",
	RESULTED = "resulted",
	POSTPONED = "postponed",
	SUSPENDED = "suspended",
}

export enum RoundStatus {
	LIVE = "playing",
	SCHEDULED = "scheduled",
	RESULTED = "resulted",
}

export enum GameStatus {
	PLAYING = "playing",
	COMPLETED = "complete",
	SCHEDULED = "scheduled",
	POSTPONED = "postponed",
	SUSPENDED = "suspended",
	CANCELED = "canceled",
}

export enum WinnerCount {
	SINGLE = "single",
	DOUBLE = "double",
	EQUAL = "equal",
}

export enum Syndication {
	FAN = "fan",
	MEDIA = "media",
}

export enum Handedness {
	LEFT = "left",
	RIGHT = "right",
	PITCHER = "pitcher",
}
